module.exports = __webpack_public_path__ + "media/images/responsive/keywords/keyword_yakei-26b81a97491dd83e3af6730606323f16.jpg";